/*
 * Copyright (c) 2019 Frontier Developments PLC.
 */

import {Vue} from 'vue-property-decorator';

import {SvgRender} from '@/directives/SvgRender';
import {imageService} from '@/directives/ImageService';

/**
 * D initialisation module.
 *
 * Adds filters into Vue instance.
 *
 * @author Jonny Cook <jcook@frontier.co.uk>
 */
Vue.directive('svg', SvgRender);
Vue.directive('img-sizes', imageService);
